import tinycolor from 'tinycolor2';

export function isProduction() {
  return import.meta.env.VITE_NODE_ENV === 'production' && !import.meta.env.VITE_IS_STAGING;
}

export const stringToColour = (str: string): [string, string] => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return [colour, tinycolor(colour).isLight() ? '#333' : '#fff'];
};
